module.exports = __webpack_public_path__ + "img/landing_page_4.ca0b017c.png";